import React from 'react';
import styled from 'styled-components';
import _ from 'lodash';

interface QuantitySelectorInputProps {
  value: number;
  setValue: (value: number) => void;
  calculatedRange?: [number, number];
  defaultRange?: [number, number];
}

interface Suggestion {
  possibleToSelect: boolean;
  value: number;
}

const BasicQuantitySelectorInput = ({
  value,
  setValue,
  calculatedRange,
  defaultRange = [0, 0],
}: QuantitySelectorInputProps) => {
  const range = defaultRange ?? [0, 0];
  const listOfSuggestions = _.range(range[0], range[1] + 1).map((suggestion) => ({
    possibleToSelect: calculatedRange ? suggestion <= calculatedRange[1] : true,
    value: suggestion,
  }));

  const suggestionIndex: { [key: string]: Suggestion } = listOfSuggestions.reduce(
    (obj, s) => ({ ...obj, [`${s.value}`]: s }),
    {},
  );

  const handleChange = (ev: React.ChangeEvent<HTMLSelectElement>) => {
    const { value } = ev.target;
    const suggestion = suggestionIndex[value]!;
    setValue(suggestion.value);
  };

  return (
    <SelectEl data-cy='tariffQuantitySelector' value={value} onChange={handleChange}>
      {listOfSuggestions.map((suggestion) => (
        <option key={suggestion.value} value={suggestion.value}>
          {suggestion.value}
        </option>
      ))}
    </SelectEl>
  );
};

const SelectEl = styled.select`
  background: #ffffff;
  border: 1px solid #949494;
  border-radius: 4px;
  width: 100%;
  height: 28px;
  box-sizing: border-box;
  position: relative;
  outline: 0px solid transparent;
  caret-color: transparent;
`;

export default BasicQuantitySelectorInput;
